import React from 'react';
import Tippy from '@tippyjs/react';
import { useNavigate } from '@reach/router';

import { getEditPageUrlFromSlug, getSuggestEditUrlFromSlug } from '../../utilities/urlHelper';

class LockedEditButton extends React.Component {
    render() {
        return (
            <Tippy content="Locked by owner" placement="bottom">
                <span
                    className="locked-edit silver page-action-btn"
                >
                    Edit
                </span>
            </Tippy>
        );
    }
}

const SuggestAnEditButton = ({ slug }) => {
    if (!slug) return null;
    const navigate = useNavigate();
    const suggestEditUrl = getSuggestEditUrlFromSlug(slug);

    const onClick = (e) => {
        if (e.metaKey || e.ctrlKey) return;
        e.preventDefault();

        return navigate(suggestEditUrl);
    };

    return (
        <a href={suggestEditUrl} className="page-action-btn" onClick={onClick}>Suggest an edit</a>
    );
};

const PageEditButton = ({ can_update, slug }) => {
    if (!slug) return null;
    const navigate = useNavigate();
    const pageEditUrl = getEditPageUrlFromSlug(slug);

    const onClick = (e) => {
        if (e.metaKey || e.ctrlKey) return;
        e.preventDefault();

        return navigate(pageEditUrl);
    };

    if (!(can_update === undefined || can_update)) {
        return <LockedEditButton />;
    }

    return <a href={pageEditUrl} className="page-action-btn" onClick={onClick}>Edit</a>;
};

export { PageEditButton, SuggestAnEditButton };
